import { SidebarState } from '.';

export function selectSidebar(state: any): SidebarState {
  return state.sidebar as SidebarState;
}
